import { useState } from "react";

const SUGGESTIONS = [
  "Why is signup→setup so low?",
  "What worked last week?",
  "Suggest one focus for this week",
  "Compare to last 4 weeks",
];

const PLACEHOLDER_REPLY =
  "Based on your PLH data, I'd recommend focusing on the highest-impact lever first. Want me to break this down or suggest experiments?";

export interface AiCoachChatPanelProps {
  open: boolean;
  onClose: () => void;
}

export function AiCoachChatPanel({ open, onClose }: AiCoachChatPanelProps) {
  const [messages, setMessages] = useState<Array<{ role: "user" | "ai"; text: string }>>([
    { role: "ai", text: "Hi! I'm your PLG Coach. Ask me about activation, funnel steps, or what to focus on this week." },
  ]);
  const [input, setInput] = useState("");

  const sendMessage = (text: string) => {
    const msg = text.trim();
    if (!msg) return;
    setMessages((prev) => [...prev, { role: "user", text: msg }]);
    setInput("");
    setTimeout(() => {
      setMessages((prev) => [...prev, { role: "ai", text: PLACEHOLDER_REPLY }]);
    }, 300);
  };

  const handleSend = () => sendMessage(input);
  const handleChip = (s: string) => sendMessage(s);

  if (!open) return null;

  return (
    <div className="chat-panel" role="dialog" aria-label="AI PLG Coach">
      <div className="chat-panel-hdr">
        <span className="chat-panel-title">
          <span className="chat-panel-dot" aria-hidden /> AI PLG Coach
        </span>
        <button
          type="button"
          className="chat-panel-close"
          onClick={onClose}
          aria-label="Close"
        >
          ✕
        </button>
      </div>
      <div className="chat-panel-msgs">
        {messages.map((m, i) => (
          <div key={i} className={`chat-msg ${m.role === "user" ? "chat-in" : "chat-ai"}`}>
            {m.text}
          </div>
        ))}
      </div>
      <div className="chat-panel-sug">
        {SUGGESTIONS.map((s) => (
          <button
            key={s}
            type="button"
            className="chat-sug"
            onClick={() => handleChip(s)}
          >
            {s}
          </button>
        ))}
      </div>
      <div className="chat-panel-in">
        <input
          className="chat-panel-input"
          placeholder="Ask about your PLH metrics…"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleSend()}
        />
        <button type="button" className="chat-panel-send" onClick={handleSend} aria-label="Send">
          →
        </button>
      </div>
    </div>
  );
}
